import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Radio, RadioChangeEvent } from 'antd'

import Tooltip from 'common/components/dataDisplay/Tooltip'

import Icon from '../general/Icon'

import './HeaderStyles.less'

export enum CompanyPersonalSection {
  Company = 'company',
  Personal = 'personal',
}

export interface CompanyPersonalProps {
  personalDashboardLink?: string
  companyDashboardLink?: string
  companyPersonalSection?: CompanyPersonalSection
  personalSectionEnabled: boolean
}

const CompanyPersonalComponent: React.FC<CompanyPersonalProps> = (props) => {
  const history = useHistory()
  const { t: translate } = useTranslation()

  const PersonalSectionButton: React.FC = () => (
    <Radio.Button
      className="header-dashboard-toggle"
      value={CompanyPersonalSection.Personal}
      disabled={!props.personalSectionEnabled}
    >
      Personal
    </Radio.Button>
  )

  const personalSection = props.personalSectionEnabled ? (
    <PersonalSectionButton />
  ) : (
    <Tooltip title={translate('admin-dashboard.navigation.disabled-personal-section-tooltip')}>
      <PersonalSectionButton />
    </Tooltip>
  )

  const handleChange = (e: RadioChangeEvent) => {
    const value = e.target.value
    if (value === CompanyPersonalSection.Personal) {
      history.push(props.personalDashboardLink ?? '')
    } else history.push(props.companyDashboardLink ?? '')
  }

  return (
    <Radio.Group value={props.companyPersonalSection} onChange={handleChange}>
      <Radio.Button className="header-dashboard-toggle" value={CompanyPersonalSection.Company}>
        Company
      </Radio.Button>
      {personalSection}
    </Radio.Group>
  )
}

export default CompanyPersonalComponent
